import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 56364DE5-01AE-4702-BC79-F85D07E485C7
 * name music-note-quarter-dotted
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/music-note-quarter-dotted.svg
 * tags
 * - Music 
 */
export const MusicNoteQuarterDottedIcon = createSvgIcon(<><path d="M12 13V13.56A3.96 3.96 0 0 0 10 13A4 4 0 1 0 14 17V3H12M16.5 17A1.5 1.5 0 1 1 15 18.5A1.5 1.5 0 0 1 16.5 17Z" /></>, 'MusicNoteQuarterDottedIcon');
export default MusicNoteQuarterDottedIcon